import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {themeRP} from "@pg-design/themes-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IStaticContext} from "../../../server/types/StaticContext";
import {ErrorSection} from "../components/ErrorSection";

const img404Mobile = require("../images/404_mobile.png");
const img404Desktop = require("../images/404_desktop.png");

interface IProps {
    staticContext?: IStaticContext;
}

export const NotFoundView = (props: IProps) => {
    const {staticContext} = props;

    // server side 404 status response
    if (staticContext) {
        staticContext.noMatchRoute = true;
    }

    return (
        <ErrorSection
            header="Uuups!"
            subheader="Przepraszamy, nie możemy wyświetlić tej strony. Możliwe, że zmienił się jej adres lub została usunięta."
            infoGraphic={{
                alt: "404",
                sources: [
                    {minWidthPX: 0, width: 336, height: 306, src: img404Mobile},
                    {minWidthPX: themeRP.breakpoints.numeric.md, width: 383, height: 346, src: img404Desktop}
                ]
            }}
        >
            <Button className={buttonStyle} fullWidth variant="filled_primary" href={rpAppLink.offer.listFriendly({friendlySlug: "nowe-mieszkania-i-domy"})}>
                Poszukaj ofert
            </Button>

            <Button className={buttonStyle} fullWidth variant="outlined_secondary" href={rpAppLink.base()}>
                Strona główna
            </Button>
        </ErrorSection>
    );
};

const buttonStyle = css({
    width: "20rem",
    maxWidth: "20rem"
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {themeRP} from "@pg-design/themes-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IStaticContext} from "../../../server/types/StaticContext";
import {ErrorSection} from "../components/ErrorSection";

const img404Mobile = require("../images/404_mobile.png");
const img404Desktop = require("../images/404_desktop.png");

interface IProps {
    staticContext?: IStaticContext;
}

export const NotFoundView = (props: IProps) => {
    const {staticContext} = props;

    // server side 404 status response
    if (staticContext) {
        staticContext.noMatchRoute = true;
    }

    return (
        <ErrorSection
            header="Uuups!"
            subheader="Przepraszamy, nie możemy wyświetlić tej strony. Możliwe, że zmienił się jej adres lub została usunięta."
            infoGraphic={{
                alt: "404",
                sources: [
                    {minWidthPX: 0, width: 336, height: 306, src: img404Mobile},
                    {minWidthPX: themeRP.breakpoints.numeric.md, width: 383, height: 346, src: img404Desktop}
                ]
            }}
        >
            <Button className={buttonStyle} fullWidth variant="filled_primary" href={rpAppLink.offer.listFriendly({friendlySlug: "nowe-mieszkania-i-domy"})}>
                Poszukaj ofert
            </Button>

            <Button className={buttonStyle} fullWidth variant="outlined_secondary" href={rpAppLink.base()}>
                Strona główna
            </Button>
        </ErrorSection>
    );
};

const buttonStyle = css({
    width: "20rem",
    maxWidth: "20rem"
});
